import React, { Component } from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import { Trans } from 'react-i18next';

import { Add, UserProfile, CalendarAdd, UserAdd, VehicleAdd, TagAdd } from './Common/Buttons/Icons';
import Icon from './Common/DesignSystem/Icons/Icon';
import { UserAvatarMenu } from './Common/Menus/UserAvatarMenu';

class Navbar extends Component {
    constructor(props) {
        super(props);

        // this.logOut = this.logOut.bind(this);
        this.openInviteUser = this.openInviteUser.bind(this);
        this.openAddInternalTag = this.openAddInternalTag.bind(this);
        this.openAddVehicle = this.openAddVehicle.bind(this);
        this.openMobileBooking = this.openMobileBooking.bind(this);

        this.state = {
            showOrderStatusLink: false,
        };
    }

    // TODO: remove the comment here to enable the order status link
    // componentDidMount() {
    //     // TODO: if changed here should also change in the useInventories hook at clientCode variable logic
    //     const subaruStakeholderId = 1017;
    //     const hasSubaruAccess = this.props.userSession.user?.profile_access?.active_sh_access?.find(({ stakeholderId }) => stakeholderId === subaruStakeholderId);
    //     const userIsEwelina = this.props.userSession.user?.email === 'ewelina.flair@integratedauto.com';
    //     const shouldShowOrderStatusLink = hasSubaruAccess || userIsEwelina;

    //     this.setState({ showOrderStatusLink: shouldShowOrderStatusLink });
    // }


    toggleDropdown(id) {
        const element = document.getElementById(id);
        if (!element) return;

        if(element.classList.contains('is-open')) {
            element.classList.remove('is-open');
        } else {
            $('.dropdown-pane').removeClass('is-open');
            element.classList.add('is-open');
        }
    }

    toggleMenu(id) {
        const element = document.getElementById(id);
        if (!element) return;

        element.classList.remove('is-closed');
        element.classList.toggle('is-open');
        element.classList.toggle('is-transition-overlap');
    }


    openAddVehicle() {
        this.toggleDropdown("add-dropdown")
        const base_url = (this.props.match.url).split('/')[1]
        this.props.history.push("/" + base_url + '/vehicle/New');
    }

    openAddInternalTag() {
        this.toggleDropdown("add-dropdown")
        const base_url = (this.props.match.url).split('/')[1]
        this.props.history.push("/" + base_url + '/internaltag/new');
    }

    openInviteUser() {
        this.toggleDropdown("add-dropdown")
        const base_url = (this.props.match.url).split('/')[1]
        this.props.history.push("/" + base_url + '/invitation/new');
    }

    openMobileBooking() {
        this.toggleDropdown("add-dropdown");
        const base_url = (this.props.match.url).split('/')[1]

        if(base_url == "bookings") {
            showStatusMsg("Please select a vehicle to continue making a booking");
        } else {
            this.props.history.push("/bookings");
        }
    }

    render() {
        return (
            <div>
                <div className="top-bar header">
                    <div className = "header-left float-left">
                        <div className = "header-responsive-menu-icon 16">
                            <a onClick={()=>this.toggleDropdown('sideMenu')} className = "menu-icon"></a>
                        </div>
                        <div className = "header-logo float-left">
                            <Link to = "/home">
                                <img src={this.props.settings.nav_logo} />
                                {/* <FXPLogo/> */}
                            </Link>
                        </div>
                        <ul className = "header-links medium-horizontal menu simple body pl-24">
                            <li className = "header-links-li"><Link to = "/home" className = { "header-links-a shnav-icon" +  ((this.props.location.pathname).split('/')[1] === "home" ? " menu-active" : "")}>{Icon({name: 'Home', size: 24, width: 32, height: 32, style: {margin: '0 auto', padding: '4px'}})}</Link></li>
                            {/* TODO: remove the comment here to enable the order status link */}
                            {/* {this.state.showOrderStatusLink && (
                                <li className = "header-links-li"><Link to = "/orders" className = { "header-links-a shnav-icon" +  ((this.props.location.pathname).split('/')[1] === "orders" ? " menu-active" : "")}>{Icon({name: 'Order', size: 24, width: 32, height: 32, style: {margin: '0 auto', padding: '4px'}})}</Link></li>
                            )} */}
                            <li className = "header-links-li">
                                <Link to = "/vehicleoverview" className = { "header-links-a shnav-icon" +  ((this.props.location.pathname).split('/')[1] === "vehicleoverview" ? " menu-active" : "")}>
                                    {Icon({name: this.props.settings.vehicle_type == "motorcycles" ? 'Bike' : 'Car', size: 24, width: 32, height: 32, style: {margin: '0 auto', padding: '4px'}})}
                                </Link>
                            </li>
                            <li className = "header-links-li"><Link to = "/bookings" className = { "header-links-a shnav-icon" +  ((this.props.location.pathname).split('/')[1] === "bookings" ? " menu-active" : "")}>{Icon({name: 'Calendar', size: 24, width: 32, height: 32, style: {margin: '0 auto', padding: '4px'}})}</Link></li>
                            <li className = "header-links-li"><Link to = "/useroverview" className = { "header-links-a shnav-icon" +  ((this.props.location.pathname).split('/')[1] === "useroverview" ? " menu-active" : "")}>{Icon({name: 'User', size: 24, width: 32, height: 32, style: {margin: '0 auto', padding: '4px'}})}</Link></li>
                            {
                                this.props.userSession.user.has_media_components ?
                                    <li className = "header-links-li"><Link to = "/mediaoverview" className = { "header-links-a shnav-icon" +  ((this.props.location.pathname).split('/')[1] === "mediaoverview" ? " menu-active" : "")}>{Icon({name: 'Media', size: 24, width: 32, height: 32, style: {margin: '0 auto', padding: '4px'}})}</Link></li>
                                :
                                    null
                            }
                            <li className = "header-links-li"><Link to = "/tiers" className = { "header-links-a shnav-icon" +  ((this.props.location.pathname).split('/')[1] === "tiers" ? " menu-active" : "")}>{Icon({name: 'Rating', size: 24, width: 32, height: 32, style: {margin: '0 auto', padding: '4px'}})}</Link></li>
                            <li className = "header-links-li"><Link to = "/expensesoverview" className = { "header-links-a shnav-icon" +  ((this.props.location.pathname).split('/')[1] === "expensesoverview" ? " menu-active" : "")}>{Icon({name: 'Expenses', size: 24, width: 32, height: 32, style: {margin: '0 auto', padding: '4px'}})}</Link></li>
                            <li className = "header-links-li"><Link to = "/geolocation" className = { "header-links-a shnav-icon" +  ((this.props.location.pathname).split('/')[1] === "geolocation" ? " menu-active" : "")}>{Icon({name: 'Pin', size: 24, width: 32, height: 32, style: {margin: '0 auto', padding: '4px'}})}</Link></li>
                        </ul>
                    </div>
                    <div className = "header-right float-right">
                        <div className = "header-profile-menu menu-right-profile">
                            {this.props.userSession.user.photo && this.props.userSession.user.photo !== "" ? (
                                <div className="button px-32 circle default no-margin image-container" onClick={()=>this.toggleDropdown('menu-dropdown')}>
                                    <img src={'https://digitalvms.s3.ca-central-1.amazonaws.com/profile-images/thumbnails/thumbnail_' + this.props.userSession.user.photo} className="image-src"/>
                                </div>
                            ) : (
                                <a className = "button px-32 circle default no-margin" onClick={()=>this.toggleDropdown('menu-dropdown')} style={{paddingTop:'1px', background: "#DFE3E8"}}>
                                    {UserProfile("fill-primary", "top-bar")}
                                </a>
                            )}
                            <div className="dropdown-pane add-pane" id="menu-dropdown" style={{left:"-115px"}}>
                                <UserAvatarMenu
                                    userSession={this.props.userSession}
                                    closeDropdown={() => this.toggleDropdown("menu-dropdown")}
                                    dispatch={this.props.dispatch}
                                    history={this.props.history}
                                    match={this.props.match}
                                />
                            </div>
                        </div>
                        {
                            this.props.userSession.user.has_booking_access ?
                                <div className = "header-profile-menu">
                                    <a className = "button px-32 circle mr-16 add-button primary" onClick={()=>this.toggleDropdown('add-dropdown')}>
                                        {Add("fill-primary")}
                                    </a>
                                    <div className = "dropdown-pane add-pane" id = "add-dropdown" style = {{left:"-145px"}}>
                                        <ul className = "vertical menu">
                                            <li className="booking-elements"><Link to = "/bookings/new" className = "no-padding"><span className = "list-icon">{CalendarAdd('fill-primary')}</span><Trans>Create Booking</Trans></Link></li>
                                            <li className="responsive-booking-elements"><a className = "no-padding" onClick={this.openMobileBooking}><span className = "list-icon">{CalendarAdd('fill-primary')}</span><Trans>Create Booking</Trans></a></li>
                                            {
                                                this.props.userSession.user.has_oem_access ?
                                                    <li><a className = "no-padding" onClick={this.openInviteUser}><span className = "list-icon">{UserAdd('fill-primary')}</span><Trans>Invite User</Trans></a></li>
                                                :
                                                    null
                                            }
                                            {
                                                this.props.userSession.user.has_oem_access ?
                                                    <li><a className = "no-padding" onClick={this.openAddInternalTag}><span className = "list-icon">{TagAdd('fill-primary')}</span><Trans>Add Internal Tag</Trans></a></li>
                                                :
                                                    null
                                            }
                                            <li><a className = "no-padding" onClick={this.openAddVehicle}><span className = "list-icon">{VehicleAdd('fill-primary')}</span><Trans>Add Vehicle</Trans></a></li>
                                        </ul>
                                    </div>
                                </div>
                            :
                                null
                        }
                    </div>
                </div>

                <div className = "header-side-menu off-canvas position-left" id="sideMenu" style = {{boxShadow:"2px 0px 10px rgba(0,0,0,0.1)",zIndex:"500"}}>
                    <div className = "header-side-menu-top">
                        <button className="close-button float-right" aria-label="Close alert" type="button" onClick={()=>this.toggleDropdown('sideMenu')}>
                           <span aria-hidden="true">&times;</span>
                        </button>
                    </div>  
                    <ul className = "header-side-menu-links">
                        <li><Link to = "/home" className = { "header-links-a shnav-icon has-tip" +  ((this.props.match.url).split('/')[1] === "home" ? " menu-active" : "")}><Trans>Dashboard</Trans></Link></li>
                        <li><Link to = "/bookings" className = { "header-links-a shnav-icon has-tip" +  ((this.props.match.url).split('/')[1] === "bookings" ? " menu-active" : "")}><Trans>Bookings</Trans></Link></li>
                        <li><Link to = "/useroverview" className = { "header-links-a shnav-icon has-tip" +  ((this.props.match.url).split('/')[1] === "useroverview" ? " menu-active" : "")}><Trans>Users</Trans></Link></li>
                        <li><Link to = "/vehicleoverview" className = { "header-links-a shnav-icon has-tip" +  ((this.props.match.url).split('/')[1] === "vehicleoverview" ? " menu-active" : "")}><Trans>Vehicles</Trans></Link></li>
                        <li><Link to = "/tiers" className = { "header-links-a shnav-icon has-tip" +  ((this.props.match.url).split('/')[1] === "tiers" ? " menu-active" : "")}><Trans>Tiers</Trans></Link></li>
                        {
                            this.props.userSession.user.has_media_components ?
                                <li><Link to = "/mediaoverview" className = { "header-links-a shnav-icon has-tip" +  ((this.props.match.url).split('/')[1] === "mediaoverview" ? " menu-active" : "")}><Trans>Media</Trans></Link></li>
                            :
                                null
                        }
                        <li><Link to = "/expensesoverview" className = { "header-links-a shnav-icon has-tip" +  ((this.props.match.url).split('/')[1] === "expensesoverview" ? " menu-active" : "")}><Trans>Expenses</Trans></Link></li>
                    </ul>
                </div>
            </div>
        )
    }
}

const mapStateToProps = store => ({
	userSession: store.userSession,
	settings: store.settings
});

export default connect(mapStateToProps)(Navbar);